import { UntitledIcon } from '@faceup/icons'
import { ulMenu01 } from '@faceup/icons/ulMenu01'
import { ulXClose } from '@faceup/icons/ulXClose'
import { defineMessages, useIntl } from '@faceup/localization'
import { Button } from '@faceup/ui-base'
import { type FragmentType, getFragmentData, graphql } from '../../../../../__generated__'
import { useClient } from '../../../../../App/ClientProvider'

import { LanguageDropdown } from '../../../../LanguageDropdown/LanguageDropdown'
import { LogoutButton } from '../../../../LogoutButton'
import { PartnerInstitutionLogo } from './PartnerInstitutionLogo'

const messages = defineMessages(
  'followUp.components.institutionLayout.components.header.components.headerComplexWithoutPages',
  [
    { id: 'openMenu', defaultMessage: 'Open menu' },
    { id: 'closeMenu', defaultMessage: 'Close menu' },
  ] as const
)

const fragments = {
  HeaderComplexWithoutPages_reportSource: graphql(`
    fragment HeaderComplexWithoutPages_reportSource on PublicReportSource {
      id
      languages
      defaultLanguage

      ...PartnerInstitutionLogo_reportSource
    }
  `),
}

type HeaderComplexWithoutPagesProps = {
  reportSource: FragmentType<typeof fragments.HeaderComplexWithoutPages_reportSource>
  isMenuOpened: boolean
  setIsMenuOpened: (isOpened: boolean) => void
}

export const HeaderComplexWithoutPages = ({
  reportSource: _reportSource,
  isMenuOpened,
  setIsMenuOpened,
}: HeaderComplexWithoutPagesProps) => {
  const reportSource = getFragmentData(
    fragments.HeaderComplexWithoutPages_reportSource,
    _reportSource
  )
  const { client } = useClient()
  const { formatMessage } = useIntl()
  const isApp = client === 'app'

  return (
    <div className='flex h-full w-full items-center justify-between'>
      <div className='flex-1' />
      <div className='flex max-h-full flex-1 justify-center'>
        <PartnerInstitutionLogo reportSource={reportSource} />
      </div>
      <div className='flex flex-1 justify-end'>
        <div className='hidden sm:flex'>
          {reportSource.languages.length > 1 && (
            <LanguageDropdown
              availableLanguages={reportSource.languages ?? []}
              defaultLanguage={reportSource.defaultLanguage}
            />
          )}
          {isApp && <LogoutButton />}
        </div>
        <div className='sm:hidden'>
          <Button
            type='text'
            icon={<UntitledIcon icon={isMenuOpened ? ulXClose : ulMenu01} size={24} />}
            label={formatMessage(isMenuOpened ? messages.closeMenu : messages.openMenu)}
            onClick={() => setIsMenuOpened(!isMenuOpened)}
          />
        </div>
      </div>
    </div>
  )
}
